export function getRecipeCost(compositions) {
  return compositions.length === 0
    ? 0
    : compositions.map((composition) => composition.entity.renderCost).reduce((a, b) => a + b, 0);
}

export default {
  getRecipeCost,
};
